const onlyCurrency = value => /^[\d.,]{0,}$/g.test(value);

export default onlyCurrency;
